// extracted by mini-css-extract-plugin
export default {"photo":"photo--wM1BU","btn":"btn--bk_xK","icon":"icon--PrbAk","title":"title--CtplF","invalidStateBtn":"invalidStateBtn--DRd3F","email":"email--nW_RV","heading":"heading--llBA3"};